<template>
  <BasePageContainer class="pt-10 px-2">
    <PageHeader
      has-back
      with-members>
      テスト成績管理
    </PageHeader>
    <AcademicRecordsForm
      ref="form"
      :existing-academic-records="academicRecords"
      :user-id="userId"
      @submit="onSubmit" />
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import AcademicRecordsForm from '@/components/view/profile/academic_records/AcademicRecordsForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    AcademicRecordsForm,
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      academicRecords: []
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchAcademicRecords().then(res => {
      this.academicRecords = res.data.results
    }).finally(() => {
      this.$store.commit('finishLoading')
    })
  },
  methods: {
    async onSubmit(formData) {
      this.$store.commit('startLoading')
      this.postAcademicRecords(formData).then(() => {
        this.$store.commit('notify/set', {message: 'テスト成績を登録しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    fetchAcademicRecords() {
      return this.$axios.get('/profiles/academic-semesters/', {
        params: {
          user_id: this.userId,
        },
      })
    },
    postAcademicRecords(formData) {
      return this.$axios.post('/profiles/academic-semesters/', formData)
    }
  }
}
</script>

<style>

</style>